<style scoped>
</style>

<template>
  <AppPage>
    <template v-slot:header>
      <Row type="flex" justify="space-between" align="middle" style="margin-bottom: 10px;">
        <i-col>
          <Row type="flex" :wrap="false" :gutter="10" align="middle">
            <i-col>
              <i-input placeholder="请输入搜索内容" search @on-blur="onSearch()" @on-search="onSearch()" @on-clear="onSearch()" clearable v-model="query.value">
                <Select slot="prepend" style="width: 100px" v-model="query.key">
                  <Option value="name">名称</Option>
                  <Option value="code">编码</Option>
                </Select>
              </i-input>
            </i-col>
            <i-col v-if="$route.query.storehouseId || $route.query.pStorehouseUnitId">
              <Tag size="large" @on-close="clearBelong" closable>
                <span v-if="$route.query.storehouseId">所属仓库ID: {{ $route.query.storehouseId }}</span>
                <span v-if="$route.query.pStorehouseUnitId">上级单元ID: {{ $route.query.pStorehouseUnitId }}</span>
              </Tag>
            </i-col>
          </Row>
        </i-col>
        <i-col>
          <Button @click="$router.back()" v-if="$route.query.back" icon="md-refresh">返回</Button>
          <Button style="margin-left: 10px;" @click="refresh" icon="md-refresh">刷新</Button>
          <Button style="margin-left: 10px;" v-if="!choose" @click="addClick" icon="md-add" type="primary">新增</Button>
        </i-col>
      </Row>
    </template>
    <template v-slot="{ contentHeight }">
      <Table row-key="id" :load-data="loadChildren" :height="contentHeight" :data="dataList" :columns="columns" stripe :loading="loading.load">
        <template v-slot:storehouseId="{ row }">
          <Tooltip :content="row.storehouseCode">
            {{ row.storehouseName }}
          </Tooltip>
        </template>
        <!-- <template v-slot:pStorehouseUnitId="{ row }">
          <div>{{ row.pStorehouseUnitName }}</div>
          <div>{{ row.pStorehouseUnitCode }}</div>
        </template> -->
        <template v-slot:action="{ row }">
          <template v-if="choose">
            <Button @click="$emit('on-choose', row)" icon="md-add" size="small" type="primary">选择</Button>
          </template>
          <template v-else>
            <Button size="small" @click="addClick(row)" icon="md-add" type="primary">新增</Button>
            <Button style="margin-left: 10px;" @click="itemUpdate(row)" size="small" icon="md-settings">修改</Button>
            <Poptip style="margin-left: 10px" transfer title="确定删除吗?" confirm @on-ok="itemDel(row)">
              <Button size="small" icon="md-trash" :loading="loading.del" type="warning">删除</Button>
            </Poptip>
          </template>
        </template>
      </Table>
    </template>
    <template v-slot:footer>
      <Drawer placement="right" :title="formData && formData.id ? '修改' : '新增'" :mask-closable="false" closable transfer draggable :width="30" v-model="status.form">
        <DrawerAction :loading="loading.submit" @confirm="submit" @cancel="status.form = false">
          <UnitFrom :data="formData" ref="form" :storehouseId="currentStorehouseId" :pStorehouseUnitId="currentPStorehouseUnitId"/>
        </DrawerAction>
      </Drawer>
    </template>
  </AppPage>
</template>

<script>
import AppPage from '../../components/page/base.vue'
import DrawerAction from '../../components/drawer/action.vue'
import request from '../../api/index'
import UnitFrom from '../../components/stock/form/unit.vue'
import { getDefault } from '../../components/stock/form/unit.vue'

// function toTree (list, pid = null) {
//   return list.filter(v => v.pStorehouseUnitId === pid).map(item => {
//     item.children = toTree(list, item.id)
//     item._loading = false
//     return item
//   })
// }

export default {
  components: { AppPage, UnitFrom, DrawerAction },
  props: {
    storehouseId: { type: Number, default: null },
    pStorehouseUnitId: { type: Number, default: null },
    choose: { type: Boolean, default: false }
  },
  data () {
    const routerName = this.$route.name
    return {
      routerName,
      query: {
        key: 'name',
        value: null
      },
      loading: {
        load: false,
        submit: false,
        del: false
      },
      dataList: [],
      status: {
        form: false
      },
      formData: null
    }
  },
  computed: {
    currentStorehouseId () {
      return this.storehouseId || (this.$route.query.storehouseId ? Number(this.$route.query.storehouseId) : null)
    },
    currentPStorehouseUnitId () {
      return this.pStorehouseUnitId || (this.$route.query.pStorehouseUnitId ? Number(this.$route.query.pStorehouseUnitId) : null)
    },
    columns () {
      let choose = this.choose
      return [
        { title: '名称', key: 'name', tree: true, minWdith: 200 },
        { title: '编码', key: 'code' },
        { title: '所属仓库', key: 'storehouseId', slot: 'storehouseId' },
        // { title: '上级单元', key: 'pStorehouseUnitId', slot: 'pStorehouseUnitId' },
        { title: '地址', key: 'address', wdith: 140, ellipsis: true, tooltip: true },
        { title: '容积(L)', key: 'volume', width: 100 },
        { title: '承重(kg)', key: 'bearing', width: 100 },
        { title: '备注', key: 'remark', wdith: 140, ellipsis: true, tooltip: true },
        { title: '操作', key: 'action', slot: 'action', width: choose ? 90 : 270 },
      ]
    },
    refreshKey () {
      return [this.currentStorehouseId, this.currentPStorehouseUnitId].join('-')
    }
  },
  watch: {
    refreshKey () {
      if (this.routerName === this.$route.name) {
        this.refresh()
      }
    }
  },
  methods: {
    clearBelong () {
      this.$router.push({
        name: this.$route.name
      })
    },
    async submit () {
      try {
        const data = await this.$refs.form.getFormData()
        if (!data) {
          return this.$Message.warning('请完整填写表单')
        }
        this.loading.submit = true
        if (data.id) {
          await request.put('/storehouse/unit/' + data.id, data)
        } else {
          await request.post('/storehouse/unit', data)
        }
        this.$Message.success('操作成功')
        this.status.form = false
        if (data.id) {
          this.loadData()
        } else {
          this.refresh()
        }
      } catch (e) {
        this.$Modal.error({ title: '系统提示', content: e.message })
      }
      this.loading.submit = false
    },
    addClick (data) {
      const formData = getDefault()
      if (data) {
        formData.pStorehouseUnitId = data.id
        formData.storehouseId = data.storehouseId
      } else {
        formData.pStorehouseUnitId = this.currentPStorehouseUnitId || null
        formData.storehouseId = this.currentStorehouseId || null
      }
      this.formData = formData
      this.status.form = true
    },
    itemUpdate (item) {
      this.formData = JSON.parse(JSON.stringify(item))
      this.status.form = true
    },
    async itemDel (item) {
      this.loading.del = true
      try {
        await request.delete('/storehouse/unit/' + item.id)
        this.$Message.success('已删除')
        this.loadData()
      } catch (e) {
        this.$Modal.error({ title: '系统提示', content: e.message })
      }
      this.loading.del = false
    },
    onSearch (params) {
      if (params) {
        Object.assign(this.query, params)
      }
      this.loadData()
    },
    refresh () {
      this.query.key = 'name'
      this.query.value = null
      this.loadData()
    },
    async loadData () {
      const params = {
        pStorehouseUnitId: String(this.currentPStorehouseUnitId),
        // pStorehouseUnitId: this.currentPStorehouseUnitId,
        storehouseId: this.currentStorehouseId
      }

      if (this.query.key && this.query.value) {
        params[this.query.key] = this.query.value
      }

      this.loading.load = true
      try {
        const res = await request.get('/storehouse/unit', params)
        res.forEach(v => {
          v.children = []
          v._loading = false
        })
        this.dataList = res
      } catch (e) {
        this.$Modal.error({ title: '系统提示', content: e.message })
      }
      this.loading.load = false
    },
    async loadChildren (item, callback) {
      const res = await request.get('/storehouse/unit', {
        pStorehouseUnitId: item.id
      })
      res.forEach(v => {
        v.children = []
        v._loading = false
      })

      if (!res.length) {
        this.$Message.warning('暂无更多数据')
      }
      callback(res)
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>
